export abstract class FeatureBase {
	abstract useResponsiveComponentConfiguration: boolean;
}
